import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const useIxGenLookupArray = () => {
    const { t } = useTranslation()

    const genLookupArray = useCallback((labelsMap: any) => {
        return Object.keys(labelsMap).map(k => ({ id: Number(k), value: t(labelsMap[k]) }))
    }, [t])

    return genLookupArray
}
